import Navigation from "./Navigation";

const App = () => {
  return (
    <div>
      <Navigation />
    </div>
  );
};

export default App;
